import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import request from 'request-promise';

import SECRETS from './secrets';


const styles = (theme) =>  ({
  newUSerScreen: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 420,
  },
  margin: {
    marginTop: 20,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '100%',
  },
});

class Login extends Component {
  state = {
      user: '',
      password: '',
      repassword: '',
      nombres: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      emails: '',
      celular: 0,
      ife: 0,
      curp: '',
      created: false,
  };

  makeNewUser = () => {
    const {
      user,
      password,
      repassword,
      nombres,
      apellidoPaterno,
      apellidoMaterno,
      emails,
      celular,
      ife,
      curp,
    } = this.state;

    if (password === repassword && password.length >= 6
      && nombres.length > 0
      && apellidoPaterno.length > 0
      && apellidoMaterno.length > 0
      && ife > 0
      && curp.length > 0
    ) {
      const newUser = {
        user,
        password,
        nombres,
        apellidoPaterno,
        apellidoMaterno,
        emails,
        celular,
        ife,
        curp,
      };
      request({
        method: 'POST',
        uri: `${SECRETS.serverUrl}/api/v1/crear-civil`,
        body: newUser,
        json: true,
      })
        .then((resp) => {
          console.log(resp);
          if (resp.success) {
            this.setState({ created: true, });
          }
        })
        .catch(err => console.error(err));
    }
  };

  handleChange = name => ev => this.setState({ [name]: ev.target.value });

  render = () => {
    const { classes } = this.props;
    const {
      user,
      password,
      repassword,
      nombres,
      apellidoPaterno,
      apellidoMaterno,
      emails,
      celular,
      ife,
      curp,
      created
    } = this.state;
    if (created) return <Redirect to="/" />;
    return (
      <div className={classes.newUserScreen}>
        <div className={classes.form}>
          <TextField
            id="user"
            label="Usuario"
            className={classes.textField}
            value={user}
            onChange={this.handleChange('user')}
            margin="normal"
          />
          <TextField
            id="password"
            label="Contraseña"
            type="password"
            className={classes.textField}
            value={password}
            onChange={this.handleChange('password')}
            margin="normal"
          />
          <TextField
            id="repassword"
            label="Repite la contraseña"
            type="password"
            className={classes.textField}
            value={repassword}
            onChange={this.handleChange('repassword')}
            margin="normal"
          />
          <TextField
            id="email"
            label="Correo electrónico"
            type="text"
            className={classes.textField}
            value={emails}
            onChange={this.handleChange('emails')}
            margin="normal"
          />
          <TextField
            id="nombres"
            label="Nombres"
            type="text"
            className={classes.textField}
            value={nombres}
            onChange={this.handleChange('nombres')}
            margin="normal"
          />
          <TextField
            id="apellidoP"
            label="Apellido paterno"
            type="text"
            className={classes.textField}
            value={apellidoPaterno}
            onChange={this.handleChange('apellidoPaterno')}
            margin="normal"
          />
          <TextField
            id="apellidoM"
            label="Apellido materno"
            type="text"
            className={classes.textField}
            value={apellidoMaterno}
            onChange={this.handleChange('apellidoMaterno')}
            margin="normal"
          />
          <TextField
            id="ife"
            label="Folio de tu credencial IFE"
            type="number"
            className={classes.textField}
            value={ife}
            onChange={this.handleChange('ife')}
            margin="normal"
          />
          <TextField
            id="curp"
            label="CURP"
            type="text"
            className={classes.textField}
            value={curp}
            onChange={this.handleChange('curp')}
            margin="normal"
          />
          <TextField
            id="celular"
            label="Número celular"
            type="number"
            className={classes.textField}
            value={celular}
            onChange={this.handleChange('celular')}
            margin="normal"
          />
          <Button
            size="large"
            color="primary"
            variant="contained"
            className={classes.margin}
            onClick={this.makeNewUser}
          >
            Crear
          </Button>
        </div>
      </div>
    );
  };
}

export default withStyles(styles)(Login);
